import api from './api';
import types from './mutation-types';

export default {
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	async getParts_({ commit, state }) {
		const { searchParams, pagingInfo } = state;
		try {
			const data = await api.getParts({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data.header.code === 0) {
				// 기존 정상 처리
				const { pagingInfo: pagingInfo_1, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo_1 });
				commit(types.DEFAULT_ASSIGN, { key: 'partList', value: resultList });
			}
			if (data.header.code === 1) {
			}
			if (data.header.code === 2) {
			}
			if (data.header.code === 3) {
			}
			if (data.header.code === 4) {
			}
			if (data.header.code === 5) {
			}
			return data.header;
		} catch (error) {
			throw new Error(error?.header || error);
		}
	}
};
